let progressfader = {

    createNode: (html) => {
        var template = document.createElement('template');
        template.innerHTML = html.trim();
        return template.content.firstChild;
    },


    init: () => {

        document.querySelectorAll(".progressfader:not(.initialized)").forEach(pfNode => {

            pfNode.classList.toggle("initialized", true);

            let loader = progressfader.createNode("<div class='loaderoverlay'></div>");
            pfNode.prepend(loader);

            // Create images container
            if (!pfNode.querySelector(".images")) {
                var imageUrls = [];
                pfNode.querySelectorAll("*[data-url]").forEach(n => {
                    imageUrls.push(n.getAttribute("data-url"));
                });
                pfNode.querySelectorAll("*[data-url]").forEach(m => { m.remove(true) });
                if (imageUrls.length < 1) {
                    imageUrls = window["progressfaderimages"];
                }
                var imgs = progressfader.createNode("<div class='images'></div>");
                imageUrls.forEach(imgUrl => {
                    var img = progressfader.createNode("<img src='" + imgUrl + "' />");
                    img.addEventListener("load", (e) => {
                        var elm = e.currentTarget;
                        elm.classList.toggle("img-loaded", true);
                        checkReadyState(pfNode);
                    });
                    imgs.appendChild(img);
                });
                pfNode.appendChild(imgs);
            }

            // Create controls
            if (!pfNode.querySelector(".controls")) {
                pfNode.appendChild(progressfader.createNode("<div class='controls'><div class='slider1'><div class='slider-track'><div class='slider-handle' draggable='false'></div></div></div></div>"));
            }

            // Add hint?
            var hintText = "";
            if (pfNode.hasAttribute("data-hint")) {
                hintText = pfNode.getAttribute("data-hint");
            }
            if (hintText != "") {
                pfNode.appendChild(progressfader.createNode("<div class='hint'>" + hintText + "</div>"));
            }


            pfNode.querySelectorAll(".images img").forEach((imgNode, imgIndex, imgList) => {
                var relImgPosInStack = imgIndex / (imgList.length - 1);
                imgNode.data = imgNode.data || {};
                imgNode.data.relpos = relImgPosInStack;
                imgNode.setAttribute("data-pos", relImgPosInStack);
            });

            document.addEventListener("pointerup", (e) => {
                e.preventDefault();
                document.querySelectorAll(".progressfader .controls .slider1 .slider-handle").forEach(h => {
                    h.classList.toggle("dragging", false);
                });
            });


            document.addEventListener("pointermove", (e) => {

                var ctrlHandle = document.querySelector(".progressfader .controls .slider1 .slider-handle.dragging");

                if (ctrlHandle) {

                    let pfNode = ctrlHandle.closest(".progressfader");

                    let moveDelta = e.clientX - ctrlHandle.data.startDragMouseX;
                    let newSelfX = ctrlHandle.data.startDragSelfX + moveDelta;

                    var ctrlSlider = ctrlHandle.closest(".slider-track");
                    var sliderWidth = ctrlSlider.getBoundingClientRect().width;
                    var handleWidth = ctrlHandle.getBoundingClientRect().width;

                    newSelfX = Math.max(0, newSelfX);
                    newSelfX = Math.min(sliderWidth - handleWidth, newSelfX);

                    ctrlHandle.style.left = newSelfX + "px";

                    updateFader(pfNode);
                }
            });

            pfNode.querySelector(".controls .slider1 .slider-handle").addEventListener("pointerdown", (e) => {
                e.preventDefault();
                e.stopPropagation();
                var elm = e.currentTarget;
                var pfNode = elm.closest(".progressfader");
                var ctrlSlider = pfNode.querySelector(".controls .slider1 .slider-track");
                var ctrlHandle = ctrlSlider.querySelector(".slider-handle");
                ctrlHandle.classList.toggle("dragging", true);
                ctrlHandle.data = ctrlHandle.data || {};
                ctrlHandle.data.startDragMouseX = e.clientX;
                ctrlHandle.data.startDragSelfX = parseFloat(ctrlHandle.style.left) || 0;
            });

            
            pfNode.querySelector(".controls .slider1 .slider-track").addEventListener("pointerdown", (e) => {
                var elm = e.currentTarget;
                var pos = relativeCoords(e);

                var pfNode = elm.closest(".progressfader");
                var ctrlSlider = pfNode.querySelector(".controls .slider1 .slider-track");
                var ctrlHandle = ctrlSlider.querySelector(".slider-handle");

                var sliderWidth = ctrlSlider.getBoundingClientRect().width;
                var handleWidth = ctrlHandle.getBoundingClientRect().width;

                pos.x = Math.max(pos.x, handleWidth / 2);
                pos.x = Math.min(pos.x, sliderWidth - handleWidth / 2);
                pos.x -= handleWidth / 2;

                var sizeOfSliderWidth = elm.getBoundingClientRect().width;
                sizeOfSliderWidth -= handleWidth;

                var relativePosition = pos.x / sizeOfSliderWidth;

                pfNode.data = pfNode.data || {};
                pfNode.data.relpos = relativePosition;

                updateFaderControls(pfNode);
                updateFader(pfNode);

                ctrlHandle.classList.toggle("dragging", true);
                ctrlHandle.data = ctrlHandle.data || {};
                ctrlHandle.data.startDragMouseX = e.clientX;                
                ctrlHandle.data.startDragSelfX = parseFloat(ctrlHandle.style.left) || 0;
            });
           

            updateFader(pfNode);
        });


        function relativeCoords(event) {
            var elm = event.currentTarget;
            var bounds = elm.getBoundingClientRect();
            var cx = event.clientX - bounds.left;
            var cy = event.clientY - bounds.top;
            var pos = { "x": cx, "y": cy };
            return pos;
        }


        function checkReadyState(pfNode) {
            var isReady = pfNode.querySelectorAll(".images img:not(.img-loaded").length === 0;
            if (isReady) {
                pfNode.classList.toggle("imagesloaded", true);
                window.setTimeout(() => {
                    pfNode.querySelector(".loaderoverlay").remove(true);
                    window.setTimeout(() => {
                        pfNode.querySelectorAll(".hint").forEach(h => { h.classList.toggle("show", true) });
                    }, 300);
                }, 400);
            }
        }

        function updateFader(pfNode) {
            var now = new Date().valueOf();
            var last = (pfNode.data && pfNode.data.lastcall) ? pfNode.data.lastcall : 0;
            if (now - last > 30) {
                updateFaderThrottled(pfNode);
                pfNode.data = pfNode.data || {};
                pfNode.data.lastcall = now;
            }
        };


        function updateFaderThrottled(pfNode) {
            pfNode.querySelectorAll(".hint").forEach(h => { h.classList.toggle("show", false) });
            var ctrlSlider = pfNode.querySelector(".controls .slider1 .slider-track");
            var ctrlHandle = ctrlSlider.querySelector(".slider-handle");
            var sliderWidth = ctrlSlider.getBoundingClientRect().width;
            var sliderPos = ctrlSlider.getBoundingClientRect().left;
            var handleWidth = ctrlHandle.getBoundingClientRect().width;
            var handlePos = ctrlHandle.getBoundingClientRect().left;
            var relativePosition = (handlePos - sliderPos) / (sliderWidth - handleWidth);

            var firstIx = 0;
            var lastIx = 1;
            var firstRelPos = 0;
            var lastRelPos = 0;

            pfNode.querySelectorAll(".images img").forEach((imgNode, imgIndex) => {
                var relImgPosInStack = imgNode.data.relpos;
                if (relativePosition > relImgPosInStack) {
                    firstIx = imgIndex;
                    firstRelPos = imgNode.data.relpos;
                }
            });

            lastIx = firstIx + 1;
            lastIx = Math.min(lastIx, pfNode.querySelectorAll(".images img").length - 1);
            lastRelPos = pfNode.querySelectorAll(".images img").item(lastIx).data.relpos;

            var span = lastRelPos - firstRelPos;

            pfNode.querySelectorAll(".images img").forEach((imgNode, imgIndex) => {
                var opacity = 0;

                if (imgIndex == firstIx) {
                    opacity = 1;
                } else if (imgIndex == lastIx) {
                    var diff = lastRelPos - relativePosition;
                    opacity = 1 - (diff / span);
                }

                imgNode.style.opacity = opacity;
            });

            pfNode.data = pfNode.data || {};
            pfNode.data.relpos = relativePosition;
        }


        function updateFaderControls(pfNode) {
            var p = pfNode.data.relpos;
            var ctrlSlider = pfNode.querySelector(".controls .slider1 .slider-track");
            var ctrlHandle = ctrlSlider.querySelector(".slider-handle");
            var sliderWidth = ctrlSlider.getBoundingClientRect().width;
            var handleWidth = ctrlHandle.getBoundingClientRect().width;
            ctrlHandle.style.left = (p * (sliderWidth - handleWidth)) + "px";
        }

        function updateAllFaders() {
            document.querySelectorAll(".progressfader.initialized").forEach((pfNode) => {
                updateFaderControls(pfNode);
            });
        }

        window.addEventListener("resize", (evt) => {
            updateAllFaders();
        });

    }
}

progressfader.init();